import { useEffect } from 'react';
import { getAllergies } from '../../../apiHandler/actions/profile';

const Component = props => {
    const {allergies, setAllergies} = props;
    
    useEffect(()=>{
        if(allergies === null) fetchAllergies();
    // eslint-disable-next-line
    },[])
    
    const fetchAllergies = async () => {
        const response = await getAllergies(props.uuid);
        setAllergies(response);
    };
    
    return (
        <div className="mj-container">
            <div>
                <p className="mj-allergy-title">Allergies to Medicine</p>
                { allergies ? 
                    <p className="mj-no-records">something</p> 
                    : 
                    <p className="mj-no-records">No records to display</p>
                }
            </div>
            <div>
                <p className="mj-allergy-title">Allergies to Food</p>
                { allergies ? 
                    <p className="mj-no-records">something</p> 
                    : 
                    <p className="mj-no-records">No records to display</p>
                }
            </div>
            <div>
                <p className="mj-allergy-title">Other Allergies</p>
                { allergies ? 
                    <p className="mj-no-records">something"</p> 
                    : 
                    <p className="mj-no-records">No records to display</p>
                }
            </div>
        </div>
    );
};

export default Component;